import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  /* The drag library measures this wrapper, so the gap between rows lives here */
  .item {
    padding-bottom: 0.5rem;
  }

  .row {
    display: flex;
    gap: 0.5rem;
    align-items: center;

    /* Hidden options read as off, like the hidden rows of the other lists */
    &.hidden {
      .drag-handle {
        color: var(--color-neutral-light);
      }

      input {
        color: var(--color-neutral-150);
        background: transparent;
        border-color: var(--color-neutral-base);
      }
    }
  }

  .drag-handle {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 32px;
    color: var(--color-neutral-150);
    cursor: grab;

    svg {
      width: 16px;
      height: 11px;
    }
  }

  /* Looks like the app's text fields: a visible outlined box, brighter while typing */
  input {
    flex: 1;
    min-width: 0;
    height: 44px;
    padding: 0 0.875rem;
    font-family: Inter, sans-serif;
    font-size: 0.875rem;
    font-weight: 700;
    color: var(--color-neutral-white);
    background: var(--color-neutral-darkness);
    border: 2px solid var(--color-neutral-light);
    border-radius: 10px;
    transition: border-color 0.15s;

    &:hover {
      border-color: var(--color-neutral-150);
    }

    &:focus {
      border-color: var(--color-neutral-white);
      outline: none;
    }

    &::placeholder {
      color: var(--color-neutral-light);
    }
  }

  .add {
    display: flex;
    gap: 0.5rem;
    align-items: center;
    justify-content: center;
    height: 44px;
    font-family: Inter, sans-serif;
    font-size: 0.8125rem;
    font-weight: 700;
    color: var(--color-neutral-150);
    border: 1.5px dashed var(--color-neutral-base);
    border-radius: 10px;

    &:hover {
      color: var(--color-neutral-white);
      border-color: var(--color-neutral-light);
    }
  }
`;
